import React, { useContext, useEffect, useId, useState } from "react";
import {
  Row,
  Col,
  Card,
  Badge,
  Carousel,
  message,
  notification,
  Progress,
  Button,
} from "antd";
import {
  FaHeart,
  FaRegHeart,
  FaStar,
  FaStarHalfAlt,
  FaThumbsUp,
  FaWhatsapp,
} from "react-icons/fa";
import slider1 from "../../../assets/frontendassets/MyBusiness/MyBusiness.jpg";
import slider2 from "../../../assets/frontendassets/MyBusiness/WhatsApp Image 2025-02-13 at 19.14.47_4dc67744.jpg";
import slider3 from "../../../assets/frontendassets/MyBusiness/WhatsApp Image 2025-02-13 at 19.14.47_9f472e9f.jpg";
import mybusiness from "../../../assets/frontendassets/mybusiness.png";

import {
  BiCheck,
  BiLeftArrow,
  BiPhoneCall,
  BiRightArrow,
} from "react-icons/bi";
import { VscWorkspaceTrusted } from "react-icons/vsc";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import verifiedlogo from "../../../assets/frontendassets/Verification Icons/1.png";
import trustedLogo from "../../../assets/frontendassets/Verification Icons/2.png";
import physicalLogo from "../../../assets/frontendassets/Verification Icons/3.png";
import TopRated from "../../../assets/frontendassets/Verification Icons/4.png";
import {
  BusinessVerified,
  createRazorpayOrder,
  getMyBusiness,
  GetSettingData,
  verifyBusinessPayment,
} from "../../../utils/API";
import { AuthContext } from "../../Auth/AuthContext";
import { MdVerified } from "react-icons/md";
import business from "../Listing/business";
import { PlusCircleIcon } from "@heroicons/react/24/outline";

const MyBusinesses = () => {
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [businessData, setBusinessData] = useState < any > ([]);

  const { authData } = useContext(AuthContext);
  const imageUrl = process.env.REACT_APP_IMAGE_URL + "/businesse/";
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifiedPaymentId, setisVerifiedPaymentId] = useState < string > ("");
  const [transactionIdTrusted, setTransactionIdTrusted] = useState < string > ("");
  const [isPaymentdoneVerified, setIsPaymentdoneVerified] = useState(false);
  const [isVeirifiedBusinessPaymentdone, setIsVeirifiedBusinessPaymentdone] =
    useState(false);
  const [isPaymentdoneTrusted, setIsPaymentdoneTrusted] = useState(false);
  const [isverifyLoading, setisverifyLoading] = useState(false);
  const currentLocation = useLocation();
  const [wishlist, setWishlist] = useState < any > ([]);
  const isLoggedIn = authData?.token;
  const [mobileNumber, setMobileNumber] = useState < string | null > (null);
  const [razorpayKey, setrazorpayKey] = useState < string | null > (null);
  const [visibleNumbers, setVisibleNumbers] = useState < {
    [key: string]: boolean;
  } > ({});
  const [isTrustedBusinessPaymentdone, setIsTrustedBusinessPaymentdone] =
    useState(false);
  const userId = authData?.user?._id;
  const navigate = useNavigate();

  const handleGetBusiness = async () => {
    try {
      const res = await getMyBusiness(userId);
      setBusinessData(res);
    } catch (error) {
      console.error("Failed to fetch business data", error);
    }
  };

  useEffect(() => {
    handleGetBusiness();
  }, []);

  const NextArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <BiRightArrow
        className={className}
        style={{
          ...style,
          fontSize: "24px",
          color: "#FFF",
          borderTopLeftRadius: "5px",
          borderBottomLeftRadius: "5px",
          position: "absolute",
          right: "0px",
          top: "50%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 0.5,
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
        onClick={onClick}
      />
    );
  };

  const PrevArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <BiLeftArrow
        className={`${className} ${showRightArrow ? "block" : "hidden"}`}
        style={{
          ...style,
          fontSize: "24px",
          color: "#FFF",
          borderTopRightRadius: "5px",
          borderBottomRightRadius: "5px",
          position: "absolute",
          left: "0px",
          top: "50%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 0.5,
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
        onClick={onClick}
      />
    );
  };

  const handleButtonClick = (business: any) => {
    navigate(`/business/${business.slug}`);
  };

  const handleNavigate = (id: any) => {
    navigate(`/business/${id}/edit`);
  };

  const updateFavicon = async () => {
    try {
      const settings = await GetSettingData();
      const razorpayKeyId = settings.settings[0].RAZORPAY_KEY_ID; // Adjust according to your API response structure
      setrazorpayKey(razorpayKeyId);
    } catch (error) {
      console.error('Error fetching favicon:', error);
    }
  };

  const handlePaymentVerified = async (businessId: any) => {
    setIsLoading(true);

    const paymentMethod = "Razorpay";

    const orderData = {
      amount: 20,
      currency: "INR",
      receipt: `receipt_verified_${Date.now()}`,
      userId,
      paymentMethod,
      transactionId: isVerifiedPaymentId,
    };

    try {
      const order = await createRazorpayOrder(orderData);
      const { id: order_id, currency, amount } = order;

      const options = {
        key: razorpayKey ? razorpayKey : process.env.RAZOR_PAY_KEY_ID,
        amount: amount.toString(),
        currency: currency,
        name: "NET4SURGE",
        description: "Test Transaction for Verified Business",
        order_id: order_id,
        handler: async function (response: any) {
          const paymentData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          };

          try {
            const verifyResult = await verifyBusinessPayment(paymentData);
            if (verifyResult === "OK") {
              const updateData = {
                isVerifiedPaymentId: response.razorpay_payment_id,
                isVerifiedPaymentStatus: 1,
                isVerified: 1,
              };
              const updateResponse = await BusinessVerified(
                businessId,
                updateData
              );
              if (updateResponse.status === 200) {
                message.success("Payment for Verified Business successful.");
                handleGetBusiness();
              } else {
                message.error("Failed to update business verification status.");
              }
            } else {
              message.error(
                "Payment for Verified Business failed. Please try again."
              );
            }
          } catch (error) {
            message.error(
              "Error verifying payment for Verified Business. Please try again."
            );
          }
        },
        prefill: {
          name: "",
          email: "",
          contact: "9999999999",
        },
        theme: {
          color: "#F37254",
        },
      };

      const rzp = new (window as any).Razorpay(options);
      rzp.open();
      setIsLoading(false);
    } catch (error: any) {
      message.error(
        "Error creating Razorpay order for Verified Business:",
        error
      );
      notification.open({
        message: "Error",
        icon: <BiCheck style={{ color: "red" }} />,
        description: "Please Login to continue!",
        placement: "topRight",
        duration: 3,
      });
      setIsLoading(false);
    }
  };

  const handlePaymentTrusted = async (businessId: any) => {
    setIsLoading(true);

    const paymentMethod = "Razorpay";

    const orderData = {
      amount: 30,
      currency: "INR",
      receipt: `receipt_trusted_${Date.now()}`,
      userId,
      deliveryNotes: "Any notes for delivery",
      paymentMethod,
      transactionId: transactionIdTrusted,
    };

    try {
      const order = await createRazorpayOrder(orderData);
      const { id: order_id, currency, amount } = order;

      const options = {
        key: razorpayKey ? razorpayKey : process.env.RAZOR_PAY_KEY_ID,
        amount: amount.toString(),
        currency: currency,
        name: "NET4SURGE",
        description: "Test Transaction for Trusted Business",
        order_id: order_id,
        handler: async function (response: any) {
          const paymentData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          };

          try {
            const verifyResult = await verifyBusinessPayment(paymentData);
            if (verifyResult === "OK") {
              setIsPaymentdoneTrusted(true);
              const updateData = {
                isTrustedPaymentId: response.razorpay_payment_id,
                isTrustedPaymentStatus: 1,
                isTrusted: 1,
              };
              const updateResponse = await BusinessVerified(
                businessId,
                updateData
              );
              if (updateResponse.status === 200) {
                message.success("Payment for Trusted Business successful.");
                handleGetBusiness();
              } else {
                message.error("Failed to update business verification status.");
              }
            } else {
              message.error(
                "Payment for Trusted Business failed. Please try again."
              );
            }
          } catch (error) {
            message.error(
              "Error verifying payment for Trusted Business. Please try again."
            );
          }
        },
        prefill: {
          name: "",
          email: "",
          contact: "9999999999",
        },
        theme: {
          color: "#F37254",
        },
      };

      const rzp = new (window as any).Razorpay(options);
      rzp.open();
      setIsLoading(false);
    } catch (error: any) {
      message.error(
        "Error creating Razorpay order for Trusted Business:",
        error
      );
      notification.open({
        message: "Error",
        icon: <BiCheck style={{ color: "red" }} />,
        description: "Please Login to continue!",
        placement: "topRight",
        duration: 3,
      });
      setIsLoading(false);
    }
  };

  const calculateProgress = (images: string | any[]) => {
    const maxImages = 4;
    let progress = 0;

    if (images && images.length > 0) {
      progress = (images.length / maxImages) * 100;
    }

    let progressText = 'Excellent'; // Default text


    if (progress == 75) {
      progressText = 'Very Strong';
    } else if (progress == 50) {
      progressText = 'Strong';
    } else if (progress == 25) {
      progressText = 'Poor';
    } else if (progress == 100) {
      progressText = 'Excellent';
    }

    return { progress, progressText };
  };


  const handleAddToWishlist = (business: any) => {
    if (!isLoggedIn) {
      // Notify the user that they need to log in
      notification.warning({
        message: "Login Required",

        description: "You must be logged in to save this to your wishlist.",
        placement: "topRight",
      });
      navigate("/login", { state: { from: currentLocation.pathname } }); // Redirect to login only if not logged in
      return;
    }

    // If the user is logged in, add to the wishlist
    setWishlist((prevWishlist: any) => [...prevWishlist, business]);
    notification.success({ message: "Business added to wishlist" });
  };

  const handlenavigate = (slug: any) => {
    navigate(`/business/${slug}`);
  };
  useEffect(() => {
    // Load wishlist from local storage
    const savedWishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
    setWishlist(savedWishlist);
  }, []);

  useEffect(() => {
    // Save wishlist to local storage
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  const isInWishlist = (business: any) => {
    return wishlist.some((item: any) => item.slug === business.slug);
  };

  const handleToggleNumberVisibility = (slug: string) => {
    setVisibleNumbers((prevState) => ({
      ...prevState,
      [slug]: !prevState[slug],
    }));
  };
  const handleRemoveFromWishlist = (business: any) => {
    if (!isLoggedIn) {
      // Notify the user that they need to log in
      notification.warning({
        message: "Login Required",
        description:
          "You must be logged in to remove items from your wishlist.",
        placement: "top",
      });
      return; // Exit the function if not logged in
    }

    setWishlist((prevWishlist: any) =>
      prevWishlist.filter((item: any) => item.slug !== business.slug)
    );
  };

  const handleEnquiryRedirect = () => {
    navigate("/contact-us");
  };

  const handleAddListingClick = () => {
    localStorage.setItem("redirectAfterLogin", "/add-listing"); // Store last visited route
    localStorage.clear();
    navigate("/login", { state: { from: "/add-listing" } }); // Always redirect to login
    
  };

  return (
    <div className="Pt-24 bg-[#FFF8EC]">
      <div className="lg:ml-20 xs:pl-10 xxs:pl-10 md:pl-10 pb-12 pt-[60px]">
        <div className="flex rounded-lg">
          <PlusCircleIcon
            className="h-auto w-10 bg-[#F9B138] rounded-tl-md rounded-bl-md p-1"
            aria-hidden="true"
            color="black"
          />
          {/* <Link to="/add-listing"> */}
            <button
              type="button"
              onClick={handleAddListingClick}
              className="bg-[#FFE8C2] rounded-none rounded-tr-md rounded-br-md btn btn-lg text-black align-items-center"
            >
              <span className="ext-white uppercase">Add New Business</span>
            </button>
          {/* </Link> */}
        </div>
      </div>

      {businessData.length === 0 ? (
        <div className="text-center h-[50vh]">
          <p className="text-gray-400 text-xl font-bold">
            No businesses listed.
          </p>
          <div className="hidden xl:flex xxl:flex justify-center mt-4">
            {/* <Link to="/add-listing"> */}
              <button
                type="button"
                onClick={handleAddListingClick}
                className="bg-[#F9B138] flex justify-center btn btn-lg text-black items-center"
              >
                <PlusCircleIcon
                  className="h-6 w-6"
                  aria-hidden="true"
                  color="black"
                />
                <span className="text-black ml-3">Add Listing</span>
              </button>
            {/* </Link> */}
          </div>
        </div>
      ) : (
        businessData.map((business: any, index: any) => (
          <div key={index} className="xl:pl-12 pb-[40px] 2xl:pl-12  lg:pl-12 lg:pr-12 pl-2 pr-2 xl:pr-12 2xl:pr-12" >
              <Row gutter={8} className="p-2">
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={8}
                xl={8}
                className="cursor-pointer"
              >
                <Carousel
                  dots={false}
                  arrows
                  autoplay
                  autoplaySpeed={3000}
                  // nextArrow={<NextArrow />}
                  // prevArrow={<PrevArrow />}
                  draggable
                  beforeChange={(from, to) => {
                    if (from === 1 && to === 2) {
                      setShowRightArrow(true);
                    }
                  }}
                >
                  {business.galleryImage.map((image: any, imgIndex: any) => (
                    <img
                      key={imgIndex}
                      className=" h-[272px] xl:h-[272px]   md:h-[350px]  w-full lg:h-[272px] rounded-xl"
                      src={`${imageUrl}${image}`}
                      alt={`Carousel ${imgIndex}`}
                      onClick={() => handleNavigate(business._id)}
                    />
                  ))}
                </Carousel>
                <div className="flex items-center justify-between pt-2 space-x-2">
                  <div className="flex-1 m-2">
                    <button className="rounded-xl w-full px-2 text-[18px] h-[55px] bg-[#F9B138]">
                      <Link to={`/backend/pricing-plan`}>
                        Upgrade Plan
                      </Link>
                    </button>
                  </div>
                  <div className="flex-1 m-2">
                    <button className="rounded-xl w-full px-2 text-[18px] md:h-[55px] xl:h-[55px] lg:h-auto shadow-md bg-[#FFF2D3]">
                      <Link to={`/business/${business._id}/edit`}>
                        Edit Business Profile
                      </Link>
                    </button>
                  </div>
                </div>

              </Col>
              <Col
                xs={24}
                sm={18}
                md={12}
                lg={9}
                xl={8}
                xxl={8}
                className="lg:p-4 md:border-r-2 sm:mt-auto sm:mb-auto lg:mt-0 border-gray-500"

              >
                <div className="flex md:pl-4 lg:pl-4 justify-between items-center md:pt-0 lg:pt-0 xl:pt-0 2xl:pt-0">
                  <div className="flex items-center">
                    <p
                      className="text-black  text-2xl xl:text-[30px] hover:text-yellow-500 font-semibold cursor-pointer"
                      onClick={() => handleNavigate(business._id)}
                    >
                      {business.businessName}
                    </p>
                  </div>
                </div>
                <div className="flex md:pl-4 lg:pl-4 flex-wrap items-center pt-2">
                  <span className="text-sm rounded-md px-3 py-1 flex items-center justify-between tracking-widest bg-green-700 text-yellow-100">
                    <span>
                      <FaStar className="text-yellow-400" />
                    </span>
                    <span className="">
                      {business.averageRating ? business.averageRating : 0}
                    </span>
                  </span>

                  <p className="text-gray-500 pl-2 text-[20px] ">
                    {business.reviews.length} Ratings
                  </p>
                  <div className="block sm:inline mt-1">
                    {business.isVerified === 2 && (
                      <Badge className="text-md font rounded-md pl-2 ml-2 pr-1 px-2 py-1 bg-green-300 text-black">
                        Verified
                      </Badge>
                    )}
                    {business.isTrusted === 2 && (
                      <Badge className="text-md font rounded-md pl-2 py-1 ml-2 pr-1 px-2 bg-yellow-200 text-black">
                        Trusted
                      </Badge>
                    )}
                  </div>
                </div>
                <p className="text-black md:pl-4 lg:pl-4  text-[20px] text-md pt-3 font-bold">
                  Address
                </p>
                <div className="flex md:pl-4 lg:pl-4 items-center pt-2">
                  <EnvironmentOutlined
                    size={20}
                    className="pr-2 text-yellow-500 font-semibold text-[20px] leading-tight"
                  />
                  <p className="text-[20px]">{`${business.buildingName}, ${business.streetName} ,${business.city} , ${business.state} , ${business.pincode}`}</p>
                </div>
                <div className="flex md:pl-4 lg:pl-4 items-center pt-3">
                  {/* <Badge className="text-sm rounded-md pl-1 pr-1 px-2 py-1 bg-slate-200 text-gray-800">
                      {business.categoryId[0].name
                        ? business.categoryId[0].name
                        : "Category"}
                    </Badge> */}
                </div>
                <div className="flex items-center flex-wrap pt-3">

                </div>
              </Col>
              <Col
                xs={24}       // Mobile: Full width
                sm={24}       // Small tablet: 50% width
                md={12}        // Medium tablet: 33% width (1/3)
                lg={7}        // Large tablet / Desktop: 7/24 width
                xl={8}        // Extra large desktop: 8/24 width
                xxl={8}       // Extra extra large desktop: 7/24 width
                className="xl:p-4 md:pt-0 text-center flex flex-col justify-center items-center"
              >
                <div className="text-[30px] font-semibold pb-3">
                  Business Profile Score
                </div>
                <div className="relative flex justify-center items-center w-44 h-44"> {/* Increased circle size */}
                  {/* Gradient Background */}
                  <div className="absolute inset-0 rounded-full bg-gradient-to-b from-yellow-400 to-red-500"></div>

                  {/* Progress Circle */}
                  <Progress
                    percent={calculateProgress(business.galleryImage).progress}
                    type="circle"
                    strokeWidth={4} // Adjust stroke width for a thicker circle border
                    trailColor="transparent" // Makes the trail invisible
                    strokeColor="transparent" // Removes stroke color
                    className="relative z-10 top-[-10%] font-bold text-[23px] text-black bg-transparent"
                    format={(percent) => `${percent}%`}
                  />
                  {/* Progress Text Inside the Circle */}
                  <div className="absolute text-[24px] top-[50%] font-semibold text-black"> {/* Increased font size */}
                    {calculateProgress(business.galleryImage).progressText}
                  </div>
                </div>

                <button
                  onClick={() => handleNavigate(business._id)}
                  className={`bg-[#FFF2D3] text-[20px] shadow-md px-4 py-2   lg:h-[55px]  cursor-pointer mt-4 rounded-xl lg:ml-4 ${calculateProgress(business.galleryImage).progress === 100 ? 'hidden' : ''
                    }`}
                >
                  {calculateProgress(business.galleryImage).progress === 100
                    ? 'Edit'
                    : 'Increase Profile Score'}
                </button>

                {calculateProgress(business.galleryImage).progress === 100 && (
                  <Button
                    onClick={() => handleNavigate(business._id)}
                    className="bg-[#FFF2D3] shadow-md px-4 py-2 font-semibold cursor-pointer mt-4 rounded-xl ml-4"
                  >
                    View
                  </Button>
                )}
              </Col>



            </Row>
          </div>
        ))
      )}
      <div className="flex items-center xl:px-12 lg:px-10 xs:px-3 xxs:px-3 mt-10">
        <hr className="w-48 xxs:w-12 xs:w-12  x h-[2px] text-black" />
        <h1 className="text-[30px] xs:text-[20px] font-normal flex items-center ml-3 ">
          Explore Listings
        </h1>
      </div>
      <div className=" mt-4 pb-5">
        <Carousel autoplay autoplaySpeed={3000}>
          <div>
            <img src={slider1} alt="Slider Image 1" className="w-full h-96 " />
          </div>
          <div>
            <img src={slider2} alt="Slider Image 2" className="w-full h-96 " />
          </div>
          <div>
            <img src={slider3} alt="Slider Image 3" className="w-full h-96 " />
          </div>
        </Carousel>
        <div className="mt-3">
          {businessData.map((business: any, index: any) => (
            <div key={index} className="xl:pl-12 pb-[40px] 2xl:pl-12  lg:pl-12 lg:pr-12 pl-2 pr-2 xl:pr-12 2xl:pr-12" >
              <Row gutter={8} className="xs:p-3 xxs:p-3">
                <Col
                  xs={24}
                  sm={24}
                  md={10}
                  lg={8}
                  xl={8}
                  className="cursor-pointer"
                >
                  <Carousel
                    dots={false}
                    arrows
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                    draggable
                    autoplay
                    autoplaySpeed={3000}
                    beforeChange={(from, to) => {
                      if (from === 1 && to === 2) {
                        setShowRightArrow(true);
                      }
                    }}
                  >
                    {business.galleryImage.map((image: any, imgIndex: any) => (
                      <img
                        className="h-48 sm:h-80 md:h-80 lg:h-52 xl:h-80 w-full  rounded-xl"
                        src={`${imageUrl}${image}`}
                        alt={`Carousel ${imgIndex}`}
                        onClick={() => navigate(`/business/${business.slug}`)}
                      />

                    ))}
                  </Carousel>
                </Col>
                <Col xs={24} sm={24} md={14} lg={12} xl={8} className="xs:pt-3 xxs:pt-3 md:px-4 py-0 ">
                  <div className="flex  md:pl-4 lg:pl-4 justify-between items-center md:pt-0 lg:pt-0 xl:pt-0 2xl:pt-0">
                    <div className="flex items-center">
                      {/* <FaThumbsUp className="text-yellow-500" size={20} /> */}
                      <p className="text-black  text-xl sm:text-2xl hover:text-yellow-500 font-bold  cursor-pointer" onClick={() => navigate(`/business/${business.slug}`)}>
                        {business.businessName}
                      </p>
                    </div>

                    <div>
                    </div>
                  </div>
                  <div className="flex  md:pl-4 lg:pl-4 flex-wrap items-center pt-2">
                    <span className="text-sm rounded-md px-3 py-1 flex items-center justify-between tracking-widest bg-green-700 text-yellow-100">
                      <span>
                        <FaStar className="text-yellow-400" />
                      </span>
                      <span className="">
                        {business.averageRating ? business.averageRating : 0}
                      </span>
                    </span>

                    <div className="flex pl-2 items-center">
                      <span className="ml-2 text-gray-700 font-medium">
                        {business.reviews.length}  Ratings
                      </span>
                    </div>

                  </div>
                  <div className="flex  md:pl-4 lg:pl-4 items-center space-x-3 ms-2 pt-3">
                    {business.isVerified === 2 && (
                      <div className="flex items-center space-x-1 ">
                        <img src={verifiedlogo} alt="logo" className="w-8 h-8" />
                        {/* <p className="text-normal font-medium text-white bg-blue-500 px-2 py-1">Verified</p> */}
                      </div>
                    )}
                    {business.isTrusted === 2 && (
                      <div className="flex items-center space-x-1">
                        <img src={physicalLogo} alt="logo" className="w-8 h-8" />
                        {/* <p className="text- font-medium text-white bg-yellow-700 px-2 py-1">Trusted</p> */}
                      </div>
                    )}
                    {business.isPhysicallyVerified === 1 && (
                      <div className="flex items-center space-x-1">
                        <img src={trustedLogo} alt="logo" className="w-8 h-8" />
                        {/* <p className="text- font-medium text-white bg-yellow-700 px-2 py-1">Trusted</p> */}
                      </div>
                    )}
                    {/* {
                      <div className="p-2 text-black text-[17px]">
                          {calculateBusinessAge(business.createdAt)}
                          </div>
                    } */}
                  </div>
                  <p className="pt-1  md:pl-4 lg:pl-4 font-bold text-lg">Address</p>
                  <div className="flex items-center pt-2 flex-wrap md:flex-nowrap">
                    {/* <EnvironmentOutlined
    size={20}
    className="pr-2 text-yellow-500 text-base"
  /> */}

                    <p className="text-[20px]  md:pl-4 lg:pl-4 leading-tight ">
                      {`${business.buildingName}, ${business.streetName},${business.city}, ${business.state} ${business.pincode}`}
                    </p>
                  </div>

                  {/* <div className="flex items-center pt-3">
                    <Badge className="text-sm rounded-md pl-1 pr-1 px-2 py-1 bg-slate-200 text-gray-800">
                      {business.categoryId[0].name}
                    </Badge>
                  </div> */}
                  <div className="flex items-center flex-wrap pt-3  md:pl-4 lg:pl-4">
                                                                     
                                                                             <Col
                                                                                 xs={8}
                                                                                 sm={8}
                                                                                 md={4}
                                                                                 lg={7}
                                                                                 xl={7}
                                                                                 xxl={7}
                                                                                 className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                                                                               >
                                                                                 <a href={`tel:${business.mobileNumber}`} target="_blank" rel="noopener noreferrer">
                                                                                   
                                                                                 <button
                                                                                   className="flex items-center h-[38px] justify-center space-x-1 px-1 py-1.5 rounded-md bg-[#118601] border-1 border-gray-900 text-white w-full text-md sm:text-md"
                                                                                 >
                                                                                   <BiPhoneCall className= "sm:text-[12px] lg:text-[19px]" color="white" fill="white" />
                                                                                   <span className= "sm:text-[12px] lg:text-[19px]">call</span>
                                                                                 </button>
                                                                                 </a>
                                                                               </Col>
                                                                               <Col
                                                                                 xs={8}
                                                                                 sm={8}
                                                                                 md={10}
                                                                                 lg={10}
                                                                                 xl={10}
                                                                                 xxl={10}
                                                                                 className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 md:ml-1 md:mr-1 w-auto"
                                                                               >
                                                                                 <Link to={`/business/${business.slug}`}>
                                                                                 <button
                                                                                   className="flex items-center h-[38px] justify-center space-x-2 px-2 py-1.5 rounded-md  border-1 border-gray-900 text-black w-full text-md sm:text-md whitespace-nowrap"
                                                                                 // onClick={handleEnquiryRedirect}
                                                                                 >
                                                                                   <FaStar className="text-yellow   sm:text-[12px] lg:text-[19px]" />
                                                                                   <span className="truncate  sm:text-[12px] lg:text-[19px]">Write Review</span>
                                                                                 </button>
                                                                                 </Link>
                                                                               </Col>
                                                                               <Col
                                                                                 xs={8}
                                                                                 sm={8}
                                                                                 md={5}
                                                                                 lg={6}
                                                                                 xl={6}
                                                                                 xxl={6}
                                                                                 className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                                                                               >
                                                                                 <Link to={`https://wa.me/${business.whatsappNumber}?text=I'm interested in ${business.businessName}`} target="_blank" rel="noopener noreferrer">
                                                                                   
                                                                                 <button
                                                                                   className="flex items-center h-[38px] justify-center space-x-1 px-1 py-1.5 rounded-md  border-1 border-gray-900 text-gray-700 w-full text-md sm:text-md"
                                                                                 >
                                                                                   <FaWhatsapp className= "sm:text-[12px] lg:text-[19px]" color="green" fill="green" />
                                                                                   <span className= "sm:text-[12px] lg:text-[19px]">Chat</span>
                                                                                 </button>
                                                                                 </Link>
                                                                               </Col>
                                                                           
                                      
                                                        </div>
                
                
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyBusinesses;
